import React, {PureComponent} from 'react'
import PropTypes from 'prop-types'
import {Form, Input, Select, InputNumber, Modal} from 'antd'

const {Option} = Select;
const formItemLayout = {
    labelCol: {
        span: 6,
    },
    wrapperCol: {
        span: 14,
    },
}
class UserModal extends PureComponent {
    state = {
        key: 0
    }
    handleOk = () => {
        const {onOk, updateKey} = this.props
        const {validateFields, getFieldsValue, resetFields} = this.props.form
        const {key} = this.state
        validateFields((errors, values) => {
            if (errors) {
                return
            }
            this.setState({
                key: updateKey
            })
            const data = {
                ...getFieldsValue(),
                key: updateKey
            }
            resetFields()
            onOk(data)
        })
    }
    hideModal = () => {
        const {onCancel} = this.props
        const {resetFields} = this.props.form
        onCancel()
        resetFields()
    }

    componentDidMount() {
        this.props.onRef(this)
    }

    render() {
        const {onOk, visible, onCancel} = this.props
        const {getFieldDecorator} = this.props.form;
        return (
            <Modal onOk={this.handleOk}
                   title="新增商品"
                   visible={visible}
                   onCancel={this.hideModal}
                   okText="确定"
                   cancelText="取消"
            >
                <Form {...formItemLayout}>
                    <Form.Item >
                        {getFieldDecorator('id', {})(<Input type='hidden'/>)}
                    </Form.Item>
                    <Form.Item label="客户单号">
                        {getFieldDecorator('platOrderNo', {
                            rules: [{required: true, message: '该项必填',},],
                        })(<Input />)}
                    </Form.Item>
                    <Form.Item label="大区">
                        {getFieldDecorator('area', {})(<Input />)}
                    </Form.Item>
                    <Form.Item label="客户简称">
                        {getFieldDecorator('customerName', {
                            rules: [{required: true, message: '该项必填',},],
                        })(<Input />)}
                    </Form.Item>
                    <Form.Item label="随箱编号">
                        {getFieldDecorator('boxNo', {})(<Input />)}
                    </Form.Item>
                    <Form.Item label="运单号">
                        {getFieldDecorator('deliveryNo', {})(<Input />)}
                    </Form.Item>
                    <Form.Item label="报关类型">
                        {getFieldDecorator('declareType', {})(<Input />)}
                    </Form.Item>
                    <Form.Item label="箱数CTNS">
                        {getFieldDecorator('num', {
                            rules: [{required: true, message: '该项必填',},],
                        })(<InputNumber />)}
                    </Form.Item>
                    <Form.Item label="总重量(Kg)">
                        {getFieldDecorator('grossWeight', {
                            rules: [{required: true, message: '该项必填',},],
                        })(<InputNumber precision={2} step={0.01} suffix="kg"/>)} kg
                    </Form.Item>
                    <Form.Item label="净重(Kg)">
                        {getFieldDecorator('netWeight', {
                            rules: [{required: true, message: '该项必填',},],
                        })(<InputNumber precision={2} step={0.01} suffix="kg"/>)} kg
                    </Form.Item>
                    <Form.Item label="尺寸">
                        {getFieldDecorator('size', {})(<Input />)}
                    </Form.Item>
                    <Form.Item label="体积(CBM)">
                        {getFieldDecorator('volume', {
                            // rules: [{required: true, message: '该项必填',},],
                        })(<InputNumber precision={2} step={0.01} suffix="CBM"/>)} CBM
                    </Form.Item>
                    <Form.Item label="品名(中文)">
                        {getFieldDecorator('name', {
                            rules: [{required: true, message: '该项必填',},],
                        })(<Input />)}
                    </Form.Item>
                    <Form.Item label="品名(英文)">
                        {getFieldDecorator('nameEn', {})(<Input />)}
                    </Form.Item>
                    <Form.Item label="国内HSCode">
                        {getFieldDecorator('hscode', {
                            rules: [{required: true, max: 10, message: '该项必填且最多10个字符'}]
                        })(<Input />)}
                    </Form.Item>
                    <Form.Item label="国外HSCode">
                        {getFieldDecorator('oHscode', {
                            //rules: [{max:10, message: '该项最多10个字符'}]
                        })(<Input />)}
                    </Form.Item>
                    <Form.Item label="数量PCS">
                        {getFieldDecorator('pcsNumber', {
                            rules: [{required: true, message: '该项必填',},],
                        })(<InputNumber />)}
                    </Form.Item>
                    <Form.Item label="单件净重">
                        {getFieldDecorator('unitNetWeight', {
                            // rules: [{required: true, message: '该项必填',},],
                        })(<InputNumber precision={2} step={0.01}/>)}
                    </Form.Item>
                    <Form.Item label="单价">
                        {getFieldDecorator('value', {
                            rules: [{required: true, message: '该项必填',},],
                        })(<InputNumber precision={2} step={0.01}/>)}
                    </Form.Item>
                    <Form.Item label="币制">
                        {getFieldDecorator('currency', {
                            initialValue: 'USD',
                        })(<Select>
                            <Option value="USD">USD</Option>
                        </Select>)}
                    </Form.Item>
                    <Form.Item label="成分(备注比例)">
                        {getFieldDecorator('ingredient', {
                            // rules: [{required: true, message: '该项必填',},],
                        })(<Input />)}
                    </Form.Item>
                    <Form.Item label="用途">
                        {getFieldDecorator('application', {})(<Input />)}
                    </Form.Item>
                    <Form.Item label="链接">
                        {getFieldDecorator('picUrl', {})(<Input />)}
                    </Form.Item>
                    <Form.Item label="品牌">
                        {getFieldDecorator('brand', {})(<Input />)}
                    </Form.Item>
                </Form>
            </Modal>
        )
    }
}

UserModal.propTypes = {
    onOk: PropTypes.func,
    onCancel: PropTypes.func,
    visible: PropTypes.string,
}
const WrapUserModal = Form.create()(UserModal)
export default WrapUserModal
